import React from "react";
import { useTranslation } from "@firecms/core";
import {
    CheckIcon,
    IconButton,
    Menu,
    MenuItem,
    TranslateIcon,
    Typography,
} from "@firecms/ui";

const LOCALES: { code: string; label: string }[] = [
    { code: "tr", label: "Türkçe" },
    { code: "en", label: "English" },
    { code: "es", label: "Español" },
    { code: "de", label: "Deutsch" },
    { code: "fr", label: "Français" },
    { code: "it", label: "Italiano" },
    { code: "hi", label: "हिन्दी" },
    { code: "pt", label: "Português" },
];

function currentCode(language: string): string {
    const base = language.split("-")[0];
    return LOCALES.some((locale) => locale.code === base) ? base : "tr";
}

/** FireCMS LanguageToggle'da tr yok; varsayılan Türkçe ve listede kalır. */
export function LocaleToggle() {
    const { i18n } = useTranslation();
    const selected = currentCode(i18n.language);

    return (
        <Menu
            trigger={
                <IconButton color="inherit" aria-label="Dil değiştir">
                    <TranslateIcon size="small" />
                </IconButton>
            }
        >
            {LOCALES.map((locale) => (
                <MenuItem
                    key={locale.code}
                    onClick={() => i18n.changeLanguage(locale.code)}
                >
                    <div className="flex w-full items-center justify-between gap-4">
                        <Typography
                            variant="body2"
                            className={selected === locale.code ? "font-bold" : ""}
                        >
                            {locale.label}
                        </Typography>
                        {selected === locale.code && <CheckIcon size="small" />}
                    </div>
                </MenuItem>
            ))}
        </Menu>
    );
}
